import objectHash from "object-hash";
import Parse from "parse";
import { TicketData, TicketManager } from "../..";
import { Ticket } from "../../../../js/parsegenerated";
import {
  getTicketHashObject,
  getTicketHashOptions,
  setTicketHashObject,
  TicketHashes,
} from "../../_shared/hooks/useTicketUpdate";
import { SaveTicketValuesWithFullMeta } from "../types/SaveTicketValues";

export type SaveResult = {
  success: boolean;
  error?: string;
  ticket?: Ticket;
};

/**
 * Use this function to save a ticket.
 * @param values only the values that are needed to save a ticket.
 * @returns a result object with the success status and the ticket object.
 */
export async function saveTicket(
  values: SaveTicketValuesWithFullMeta
): Promise<TicketData | undefined> {
  const response: SaveResult = await Parse.Cloud.run(
    "openinc-openservice-save-ticket-data",
    values
  );

  if (!response.success) throw new Error(response.error);

  const ticketData = await TicketManager.Get(response.ticket?.id);

  // save ticket hash
  if (ticketData?.ticket) setTicketHash(ticketData);

  return ticketData;
}

function setTicketHash(ticketData: TicketData) {
  const currentHashes: TicketHashes = getTicketHashObject();
  currentHashes[ticketData.ticket.id] = objectHash(
    ticketData,
    getTicketHashOptions()
  );

  setTicketHashObject(currentHashes);
}
